// Microsecond precision, so two rows written in the same millisecond are still ordered.
// The sub-second part comes straight off the ISO string because a JS Date only keeps
// millis, and the rest from Date parts because the locale formatter drops sub-seconds.
export function formatEventTime(at: string): string {
  const d = new Date(at);
  const pad = (n: number) => String(n).padStart(2, '0');
  const ymd = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const hms = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  const frac = (/\.(\d+)/.exec(at)?.[1] ?? '').concat('000000').slice(0, 6);
  return `${ymd} ${hms}.${frac}`;
}

// Seconds -> "m:ss"; recordings are short, so there is no hours case. Zero means "no
// duration to report" — a call still open, or one with no terminal event — not a
// zero-length call, so it renders "—".
export function formatDuration(sec: number | null): string {
  if (sec == null || sec <= 0) return '—';
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
